import React, { useEffect, useState } from "react";
import Form, {
  SimpleItem, GroupItem, Label, RequiredRule, ButtonItem, ButtonOptions, TabbedItem, TabPanelOptions, Tab
} from 'devextreme-react/form';
import { LVForm } from "../Basicos/LVForm";
import ComboAbmZonPlantas from "../Compuestos/Combos/ComboAbmZonPlantas";
import ComboAbmZonEmpresas from "../Compuestos/Combos/ComboAbmZonEmpresas";
import LVButtonAccion from "../Basicos/LVButtonAccion";
import { LVGridCarga } from "../Basicos/LVGridCarga";
import { Column } from "devextreme-react/data-grid";
import { function_ABM_CON_CentrosCosto_Generar_JSON, function_ABM_CON_CentrosCosto_Insertar, function_ABM_CON_CentrosCosto_Leer, function_ABM_CON_CentrosCosto_Modificar } from "neftis7_apicaller/src/funciones/ABM/CONT/ABM_CON_CentrosCosto";

const ABM_CON_CentrosCosto = (props) => {
  const [datos, setDatos] = useState([]);
  const [TituloBoton, setTituloBoton] = useState("");
  const [accionBoton, setAccionBoton] = useState("");
  const [esModificacion, setEsModificacion] = useState(false);
  const [esMultiEmpresa, setEsMultiEmpresa] = useState(true);
  const [esMultiPlanta, setEsMultiPlanta] = useState(true);
  const [plantaSeleccionada, setPlantaSeleccionada] = useState(null);
  const [empresaSeleccionada, setEmpresaSeleccionada] = useState(null);

  const handleOnValueChangedMultiEmpresa = (e) => {
    const isChecked = e.value;

    setEsMultiEmpresa(isChecked)
    setDatos((prevDatos) => ({
      ...prevDatos,
      MultiEmpresa: isChecked
    }));
  };

  const handleOnValueChangedMultiPlanta = (e) => {
    const isChecked = e.value;

    setEsMultiPlanta(isChecked)
    setDatos((prevDatos) => ({
      ...prevDatos,
      MultiPlanta: isChecked
    }));
  };

  const handleOnClick_AgregarPlanta = async (e) => {
    if (!plantaSeleccionada.codigo) {
      alert("Seleccione una Planta antes de agregar.");
      return;
    }

    // Verificar si ya está en la lista
    const plantaYaExiste = datos.ListPlantas?.some(
      (planta) => planta.ABM_ZON_Plantas_CodigoPlanta === plantaSeleccionada.codigo
    );

    if (plantaYaExiste) {
      alert("La Planta ya ha sido agregada.");
      return;
    }

    // Crear el nuevo objeto
    const nuevaPlanta = {
      ABM_ZON_Plantas_CodigoPlanta: plantaSeleccionada.codigo,
      CodigoPlanta: plantaSeleccionada.codigo,
      Descripcion: plantaSeleccionada.descripcion,
      CodigoCompania: localStorage.getItem("CodigoCompania"),
      ABM_ART_Articulos_CodigoArticulo: ""
    };

    // Agregar el nuevo item a la coleccion
    setDatos((prevDatos) => ({
      ...prevDatos,
      ListPlantas: [...(prevDatos.ListPlantas || []), nuevaPlanta],
    }));

    // Limpiar la selección después de agregar
    setPlantaSeleccionada(null);
  }

  const handleOnClick_AgregarEmpresa = async (e) => {
    if (!empresaSeleccionada.codigo) {
      alert("Seleccione una Empresa antes de agregar.");
      return;
    }

    // Verificar si ya está en la lista
    const empresaYaExiste = datos.ListEmpresas?.some(
      (empresa) => empresa.ABM_ZON_Empresas_CodigoEmpresa === empresaSeleccionada.codigo
    );

    if (empresaYaExiste) {
      alert("La Empresa ya ha sido agregada.");
      return;
    }

    // Crear el nuevo objeto
    const nuevaEmpresa = {
      ABM_ZON_Empresas_CodigoEmpresa: empresaSeleccionada.codigo,
      CodigoEmpresa: empresaSeleccionada.codigo,
      Descripcion: empresaSeleccionada.descripcion,
      CodigoCompania: localStorage.getItem("CodigoCompania"),
      ABM_ART_Articulos_CodigoArticulo: ""
    };

    // Agregar el nuevo item a la coleccion
    setDatos((prevDatos) => ({
      ...prevDatos,
      ListEmpresas: [...(prevDatos.ListEmpresas || []), nuevaEmpresa],
    }));

    // Limpiar la selección después de agregar
    setEmpresaSeleccionada(null);
  }

  const handleOnClick_Guardar = async (e) => {
    try {

      const JSON = await function_ABM_CON_CentrosCosto_Generar_JSON(
        datos.CodigoCC,
        datos.Descripcion,
        datos.MultiPlanta,
        datos.MultiEmpresa,
        datos.ListPlantas,
        datos.ListEmpresas
      )

      if (props.Codigo.Codigo === "--NUEVO--") {

        const Creado = await function_ABM_CON_CentrosCosto_Insertar(JSON, false)

        alert("Se ha generado el Código: " + Creado.data.codigoGenerado)
      } else {

        const Modificado = await function_ABM_CON_CentrosCosto_Modificar(JSON, false)

        alert("Se ha modificado el Código: " + datos.CodigoCC)
      }

      window.location.reload()
    } catch (error) {
      alert(error)
    }
  }

  useEffect(() => {

    const getData = async () => {
      try {
        if (props.Codigo.Codigo === "--NUEVO--") {
          setTituloBoton("GUARDAR")
          setAccionBoton("GUARDAR")

          setDatos({
            CodigoCC: '',
            Descripcion: '',
            MultiPlanta: true,
            MultiEmpresa: true
          })
        } else {
          setTituloBoton("ACTUALIZAR CÓDIGO " + props.Codigo.Codigo)
          setAccionBoton("ACTUALIZAR CÓDIGO " + props.Codigo.Codigo)
          setEsModificacion(true)

          const datosDocumento = await function_ABM_CON_CentrosCosto_Leer(props.Codigo.Codigo)
          setDatos(datosDocumento.data[0])

          setEsMultiPlanta(datosDocumento.data[0].MultiPlanta)
          setEsMultiEmpresa(datosDocumento.data[0].MultiEmpresa)
        }
      } catch (error) {
        alert(error);
      }
    }
    getData();
  }, []);

  const validateForm = (e) => {
    e.component.validate();
  };

  return (
    <LVForm
      colCount={1}
      formData={datos}
      onContentReady={validateForm}
    >
      <TabbedItem>
        <TabPanelOptions deferRendering={false} />

        <Tab title="General" colCount={1}>
          <GroupItem caption="General">
            <SimpleItem dataField="CodigoCC" >
              <Label text="Código" />
              <RequiredRule message="Indicar el Código es obligatorio." />
            </SimpleItem>
            <SimpleItem dataField="Descripcion">
              <Label text="Descripción" />
              <RequiredRule message="Indicar la Descripción es obligatorio." />
            </SimpleItem>
          </GroupItem>
        </Tab>

        <Tab title="Plantas">
          <GroupItem>
            <SimpleItem dataField="MultiPlanta" editorType="dxCheckBox"
              editorOptions={{ onValueChanged: (e) => handleOnValueChangedMultiPlanta(e) }}>
              <Label text="MultiPlanta (Desactivado permite definir para que Plantas estará disponible)" />
            </SimpleItem>
          </GroupItem>

          <GroupItem visible={!esMultiPlanta}>
            <div className="LV-FlexContainer" style={{ marginBottom: '20px' }}>
              <ComboAbmZonPlantas
                ancho="500"
                CodigoCompania={localStorage.getItem("CodigoCompania")}
                CodigoEmpresa={localStorage.getItem("CodigoEmpresa")}
                CodigoPlanta={localStorage.getItem("CodigoPlanta")}
                onValueChanged={(e) => {
                  const descripcion = e.component && typeof e.component.option === "function"
                    ? e.component.option("text")
                    : "";
                  setPlantaSeleccionada({ codigo: e.value, descripcion });
                }} />
              <LVButtonAccion Texto={"AGREGAR PLANTA"} onClick={handleOnClick_AgregarPlanta} />
            </div>

            <LVGridCarga
              id="gridContainer"
              dataSource={datos.ListPlantas}
              keyExpr="ABM_ZON_Plantas_CodigoPlanta"
            >
              <Column caption="Código" dataField="ABM_ZON_Plantas_CodigoPlanta" width="80" alignment="Left" dataType="string" />
              <Column caption="Descripción" dataField="Descripcion" width="100%" minWidth="200" alignment="Left" dataType="string" />
            </LVGridCarga>
          </GroupItem>
        </Tab>

        <Tab title="Empresas">
          <GroupItem>
            <SimpleItem dataField="MultiEmpresa" editorType="dxCheckBox"
              editorOptions={{ onValueChanged: (e) => handleOnValueChangedMultiEmpresa(e) }}>
              <Label text="MultiEmpresa (Desactivado permite definir para que Empresas estará disponible)" />
            </SimpleItem>
          </GroupItem>

          <GroupItem visible={!esMultiEmpresa}>
            <div className="LV-FlexContainer" style={{ marginBottom: '20px' }}>
              <ComboAbmZonEmpresas
                ancho="500"
                CodigoCompania={localStorage.getItem("CodigoCompania")}
                CodigoEmpresa={localStorage.getItem("CodigoEmpresa")}
                CodigoPlanta={localStorage.getItem("CodigoPlanta")}
                onValueChanged={(e) => {
                  const descripcion = e.component && typeof e.component.option === "function"
                    ? e.component.option("text")
                    : "";
                  setEmpresaSeleccionada({ codigo: e.value, descripcion });
                }} />
              <LVButtonAccion Texto={"AGREGAR EMPRESA"} onClick={handleOnClick_AgregarEmpresa} />
            </div>

            <LVGridCarga
              id="gridContainer"
              dataSource={datos.ListEmpresas}
              keyExpr="ABM_ZON_Empresas_CodigoEmpresa"
            >
              <Column caption="Código" dataField="ABM_ZON_Empresas_CodigoEmpresa" width="80" alignment="Left" dataType="string" />
              <Column caption="Descripción" dataField="Descripcion" width="100%" minWidth="200" alignment="Left" dataType="string" />
            </LVGridCarga>
          </GroupItem>
        </Tab>
      </TabbedItem>

      <ButtonItem horizontalAlignment="Center">
        <ButtonOptions onClick={handleOnClick_Guardar} type='success' useSubmitBehavior={true} text={TituloBoton} />
      </ButtonItem>
    </LVForm>
  );

}

export default ABM_CON_CentrosCosto;